module.exports = __webpack_public_path__ + "img/1_032.bc6a3dc5.jpg";